import React from 'react';

import { getActivityExtent, getAllDates } from 'helpers/mapHelpers';

const ActivitiesDates = ({ activities = [] }) => {
  const allActivitiesDates = activities
    .filter(activity => activity.eventDates)
    .reduce((acc, curr) => [...acc, ...curr.eventDates], []);

  const allDates = getAllDates(allActivitiesDates);

  if (!allDates.length) {
    return '';
  }

  const [startDate, endDate] = getActivityExtent(allDates);

  const start = startDate.format('DD/MM/YYYY');
  const end = endDate.format('DD/MM/YYYY');

  if (start === end) {
    return <div>Le {start}</div>;
  }
  return <div>Entre le {start} <br /> et le {end}</div>;
};

export default ActivitiesDates;



// WEBPACK FOOTER //
// ./src/components/Userrequest/ActivitiesDates.js